export const supportedLocales = ['en', 'cs'] as const;

export type Locale = typeof supportedLocales[number];

export const defaultLocale: Locale = 'en';
export const localeCookieName = 'acolyte_locale';

export function isLocale(value: unknown): value is Locale {
  return (
    typeof value === 'string' &&
    supportedLocales.includes(value.toLocaleLowerCase() as Locale)
  );
}

export function normalizeLocale(value: unknown): Locale | null {
  if (!isLocale(value)) {
    return null;
  }

  return value.toLocaleLowerCase() as Locale;
}

export function getLocaleFromCookieHeader(
  cookieHeader?: string | null
): Locale | null {
  if (!cookieHeader) {
    return null;
  }

  const encodedLocale = cookieHeader
    .split(';')
    .map((part) => part.trim().split('='))
    .find(([name]) => name === localeCookieName)?.[1];

  if (!encodedLocale) {
    return null;
  }

  try {
    return normalizeLocale(decodeURIComponent(encodedLocale));
  } catch (error) {
    return null;
  }
}

export function getLocaleCookieOptions(isProduction: boolean) {
  return {
    httpOnly: true,
    maxAge: 365 * 24 * 60 * 60 * 1000,
    sameSite: 'lax' as const,
    secure: isProduction,
  };
}
